var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCodeBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#909090",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,11h8V3H3V11z M5,5h4v4H5V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,21h8v-8H3V21z M5,15h4v4H5V15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3v8h8V3H13z M19,9h-4V5h4V9z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 19,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 13,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 15,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 13,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 15,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 17,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 17,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 19,
    y: 15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeBlack24Dp);
export default __webpack_public_path__ + "static/media/qr_code_black_24dp.a3961eef507f0c3e7630f43eba61ec02.svg";
export { ForwardRef as ReactComponent };